/*
 * Flash Sale Header — countdown timer (2026-07-08)
 * -------------------------------------------------------------------------
 * Counts down to ONE ABSOLUTE moment for every visitor (unlike the visitor-
 * local sale-countdown-banner.js). The end time is entered in the store's
 * wall-clock time + a UTC offset, so a shopper in any timezone sees the timer
 * hit zero at the same real instant the Shopify automatic discount expires.
 *
 * Reads config from data-* attributes on each [data-flash-timer] element so
 * multiple instances on a page stay independent.
 */
(function () {
  function pad(n, prefix, zero) {
    if (n <= 0) return zero;
    return n < 10 ? prefix + n : String(n);
  }

  function initTimer(el) {
    var y = parseInt(el.dataset.endYear, 10);
    var mo = parseInt(el.dataset.endMonth, 10);
    var d = parseInt(el.dataset.endDay, 10);
    var h = parseInt(el.dataset.endHour, 10);
    var mi = parseInt(el.dataset.endMinute, 10);
    var off = parseFloat(el.dataset.utcOffset || "0");
    var showDays = el.dataset.showDays === "true";
    var prefix = el.dataset.singlePrefix != null ? el.dataset.singlePrefix : "0";
    var zero = el.dataset.zeroValue != null ? el.dataset.zeroValue : "00";

    // Wall-clock time at the given offset -> absolute UTC epoch.
    // local = UTC + off  =>  UTC = local - off
    // This anchor is the END in "fixed" mode, or the START in "duration" mode.
    var anchor = Date.UTC(y, mo - 1, d, h - off, mi, 0);

    var mode = el.dataset.timerMode || "fixed";
    var durationMs = (parseFloat(el.dataset.durationMinutes) || 0) * 60000;
    var target = mode === "duration" ? anchor + durationMs : anchor;

    var root = el.closest(".flash-sale") || el;
    var daysEl = el.querySelector("[data-unit=days]");
    var hoursEl = el.querySelector("[data-unit=hours]");
    var minsEl = el.querySelector("[data-unit=minutes]");
    var secsEl = el.querySelector("[data-unit=seconds]");
    var daysItem = el.querySelector("[data-item=days]");

    function render() {
      var diff = target - Date.now();

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = zero;
        if (hoursEl) hoursEl.textContent = zero;
        if (minsEl) minsEl.textContent = zero;
        if (secsEl) secsEl.textContent = zero;
        root.classList.add("flash-sale--ended");
        return false; // stop ticking
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      // If days are hidden, roll their hours into the hours slot.
      if (!showDays) hours += days * 24;
      else if (daysItem) daysItem.hidden = false;

      if (showDays && daysEl) daysEl.textContent = pad(days, prefix, zero);
      if (hoursEl) hoursEl.textContent = pad(hours, prefix, zero);
      if (minsEl) minsEl.textContent = pad(minutes, prefix, zero);
      if (secsEl) secsEl.textContent = pad(seconds, prefix, zero);

      // Final-stretch flourish: pulse harder under 5 minutes.
      if (diff <= 300000) root.classList.add("flash-sale--final");
      return true;
    }

    if (render()) {
      var id = setInterval(function () {
        if (!render()) clearInterval(id);
      }, 1000);
    }
  }

  function boot() {
    var timers = document.querySelectorAll("[data-flash-timer]");
    for (var i = 0; i < timers.length; i++) initTimer(timers[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Re-init when re-rendered inside the theme editor.
  document.addEventListener("shopify:section:load", function (e) {
    var timers = e.target.querySelectorAll("[data-flash-timer]");
    for (var i = 0; i < timers.length; i++) initTimer(timers[i]);
  });
})();
